export const SOURCE_LANG_SHORT = "en";

export const WIZARD_STEP = {
  ADD_LANGUAGE: 1,
  COPY_LESSONS: 2,
  IMPORT_DATABASE: 3,
  MARK_WORDS: 4,
};

export const STEPS = [
  { number: WIZARD_STEP.ADD_LANGUAGE, label: "Add language" },
  { number: WIZARD_STEP.COPY_LESSONS, label: "Copy lessons from EN" },
  { number: WIZARD_STEP.IMPORT_DATABASE, label: "Import database" },
  { number: WIZARD_STEP.MARK_WORDS, label: "Mark words as user" },
];

export const LANGUAGE_MODE = {
  CREATE: "create",
  SELECT: "select",
};

export const DELIMITER_OPTIONS = [
  { label: "Comma (,)", value: "," },
  { label: "Semicolon (;)", value: ";" },
];
